// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__3f6Vs","row":"style_row__1oe9x","title":"style_title__1Ah3L","outlined":"style_outlined__1KZ5Z"};